module.exports = __webpack_public_path__ + "img/CB0020_cat_stroke.11ac3deb.png";